// extracted by mini-css-extract-plugin
export default {"button":"buttonInfo_button__k43O3","mobile":"buttonInfo_mobile__hKvPd","tablet":"buttonInfo_tablet__+OL-I"};